import { Header } from "@/components/Header";
import MarketplaceHome from "@/components/marketplace/MarketplaceHome";

const Index = () => {
  const isLoggedIn = !!window.__AUTH_ID__;

  if (!isLoggedIn) {
    return <MarketplaceHome />;
  }

  return (
    <>
      <Header hideAudienceNav isCompact />
      <div className="marketplace-home-auth">
        <style>{`.marketplace-home-auth > div > header { display: none; }`}</style>
        <MarketplaceHome />
      </div>
    </>
  );
};

export default Index;
